export const elipsis = (text: string, maxLength: number = 39) => {
  if (text.length <= maxLength) {
    return text;
  }
  const endingLength = 10;
  const start = text.substr(0, maxLength - endingLength);
  const end = text.substr(text.length - endingLength);
  return `${start}...${end}`;
};
